import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../../../constants/common'
import { HTML_LINK_TARGET } from '../../../../../../../constants/html'
import { getQaSelector } from '../../../../../../../utils/common'
import { FloatingTooltip } from '../../../../../../Floating'
import { Link } from '../../../../../../Link'
import { getHasListingPublicationPublicUrl } from '../../../../../../RentalPortalListing'
import {
  QA_NAME_LISTING_PROFILE_PORTAL_LINK,
  QA_NAME_LISTING_PROFILE_PORTAL_ROW,
} from '../../RentalPortalListingProfileWidgetPortals.constants'
import { getListingPortalTooltip } from '../../RentalPortalListingProfileWidgetPortals.utils'

function ListingProfileWidgetPortalsRowWrapper({
  children,
  className,
  linkClassName,
  publication,
}) {
  const { t } = useTranslation()

  return (
    <FloatingTooltip
      content={getListingPortalTooltip({ publication, t })}
      placement={FLOATING_ELEMENT_PLACEMENT.top}
    >
      {getHasListingPublicationPublicUrl(publication) ? (
        <Link
          {...getQaSelector({
            context: publication.id,
            value: QA_NAME_LISTING_PROFILE_PORTAL_LINK,
          })}
          className={linkClassName}
          rel='noopener noreferrer'
          target={HTML_LINK_TARGET.blank}
          to={publication.public_url}
        >
          {children}
        </Link>
      ) : (
        <div
          {...getQaSelector({
            context: publication.id,
            value: QA_NAME_LISTING_PROFILE_PORTAL_ROW,
          })}
          className={className}
        >
          {children}
        </div>
      )}
    </FloatingTooltip>
  )
}

export default ListingProfileWidgetPortalsRowWrapper
